/* This file was generated automatically. Do not edit manually. */

export enum ReservationContractTemplateFieldIdentifier {
    Email = 'Email',
    Title = 'Title',
    FirstName = 'FirstName',
    FirstLastName = 'FirstLastName',
    SecondLastName = 'SecondLastName',
    Nationality = 'Nationality',
    Language = 'Language',
    Telephone = 'Telephone',
    Sex = 'Sex',
    DateOfBirth = 'DateOfBirth',
    PlaceOfBirth = 'PlaceOfBirth',
    TaxIdentifier = 'TaxIdentifier',
    CardRegistrationNumber = 'CardRegistrationNumber',
    Occupation = 'Occupation',
    Company = 'Company',
    FullAddress = 'FullAddress',
    StreetMain = 'StreetMain',
    StreetAdditional = 'StreetAdditional',
    City = 'City',
    PostalCode = 'PostalCode',
    Country = 'Country',
    StateOrProvince = 'StateOrProvince',
    ReservationOwner = 'ReservationOwner',
    Service = 'Service',
    SpaceCategory = 'SpaceCategory',
    RoomNumber = 'RoomNumber',
    ConfirmationNumber = 'ConfirmationNumber',
    ArrivalDate = 'ArrivalDate',
    ArrivalTime = 'ArrivalTime',
    DepartureDate = 'DepartureDate',
    DepartureTime = 'DepartureTime',
    Rate = 'Rate',
    TotalAmount = 'TotalAmount',
    AverageBookableServiceRate = 'AverageBookableServiceRate',
    AverageBookableServiceWithProductsRate = 'AverageBookableServiceWithProductsRate',
}
